module.exports = __webpack_public_path__ + "img/w65.5c912bea.svg";